import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaCommentDots, FaTrash, FaPlus } from "react-icons/fa";
import Pagination from "Components/Pagination";
import CsReviewDetail from "Components/CsReviewDetail";
import CsReviewCreateModal from "Components/CsReviewCreateModal";
import CommonModal from "Components/CommonModal";
import { catchError, changeState, commonModalSetting } from "JS/common";
import { getReviewList, deleteReviews } from "JS/API";
import { useMarkMenuSeen } from "Contexts/NewCountContext";
import $ from "jquery";
import { listPageStyles } from "utils/designSystem";

const REVIEW_TYPES = ["출원후기", "등록가능성검토 후기"];

const CsReview = () => {
  const [pageInfo, setPageInfo] = useState({
    page: 1,
    totalPage: 1,
    limit: 10,
  });
  const [answerSelect, setAnswerSelect] = useState("all"); // all | answer | notanswer
  const [reviewType, setReviewType] = useState(""); // "" = 전체
  const [detailReview, setDetailReview] = useState(null); // 클릭한 후기 행 전체
  const [alert, setAlert] = useState("");
  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });
  const [list, setList] = useState([]);
  const [modal, setModal] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [idArr, setIdArr] = useState([]);
  const navigate = useNavigate();
  useMarkMenuSeen("cs_review");

  let prevent = false;

  // 스타일 정의
  const styles = {
    container: listPageStyles.container,
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '24px',
      flexWrap: 'wrap',
      gap: '16px'
    },
    title: listPageStyles.title,
    controlsContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      flexWrap: 'wrap',
      minWidth: 0
    },
    select: listPageStyles.select,
    deleteButton: listPageStyles.deleteButton,
    createButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 16px',
      backgroundColor: '#2563eb',
      color: '#ffffff',
      border: 'none',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    },
    adminBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: '2px 8px',
      borderRadius: '4px',
      fontSize: '11px',
      fontWeight: '600',
      backgroundColor: '#fee2e2',
      color: '#b91c1c',
      marginLeft: '8px',
      verticalAlign: 'middle'
    },
    tableContainer: listPageStyles.tableContainer,
    tableWrapper: listPageStyles.tableWrapper,
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      minWidth: '900px'
    },
    th: listPageStyles.th,
    td: listPageStyles.td,
    checkbox: listPageStyles.checkbox,
    checkboxLabel: listPageStyles.checkboxLabel,
    reviewType: {
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: '500',
      textAlign: 'center',
      whiteSpace: 'nowrap'
    },
    typeApply: {
      backgroundColor: '#dbeafe',
      color: '#1d4ed8'
    },
    typeReview: {
      backgroundColor: '#dcfce7',
      color: '#16a34a'
    },
    memberBadge: {
      padding: '2px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: '500',
      whiteSpace: 'nowrap'
    },
    memberYes: {
      backgroundColor: '#e0e7ff',
      color: '#4338ca'
    },
    memberNo: {
      backgroundColor: '#f3f4f6',
      color: '#6b7280'
    },
    titleCell: {
      fontWeight: '500',
      color: '#374151'
    },
    emptyState: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '48px 24px',
      color: '#64748b',
      fontSize: '16px'
    }
  };

  // 후기 유형별 스타일 반환
  const getReviewTypeStyle = (type) => {
    const baseStyle = styles.reviewType;
    switch (type) {
      case '출원후기':
        return { ...baseStyle, ...styles.typeApply };
      case '등록가능성검토 후기':
        return { ...baseStyle, ...styles.typeReview };
      default:
        return { ...baseStyle, ...styles.typeReview };
    }
  };

  //= 후기 목록 불러오기
  const getReviews = async () => {
    if (prevent) return; // 중복 호출 방지
    prevent = true;
    setTimeout(() => {
      prevent = false;
    }, 200);

    const result = await getReviewList(
      pageInfo.page,
      pageInfo.limit,
      reviewType,
      answerSelect
    );
    if (typeof result === "object") {
      setList(result?.data?.data);
      changeState(setPageInfo, "totalPage", result?.data?.meta?.total_page);
    } else return await catchError(result, navigate, setAlertBox, setAlert);
  };

  //= 후기 목록 테이블 렌더
  const renderTableBody = () => {
    return list.map((row) => {
      const {
        id,
        review_type,
        title,
        author_name,
        is_member,
        is_admin,
        created_at,
      } = row;

      // 개별 선택
      const checkEach = (e) => {
        e.stopPropagation();
        let all = $(".review-check").length;
        let checked = $(".review-check:checked").length;
        let arr = [];
        if (all !== checked) $(".review-all-check").prop("checked", false);
        else $(".review-all-check").prop("checked", true);
        for (let i = 0; i < all; i++) {
          if (document.getElementsByClassName("review-check")[i].checked) {
            const val =
              document.getElementsByClassName("review-check")[i].value;
            arr.push(val);
            setIdArr(arr);
          }
        }
      };

      //& 목록 클릭 시 상세 모달 (행 전체 전달 → 연락처 노출)
      const onModal = () => {
        setDetailReview(row);
        setModal(true);
      };

      return (
        <tr
          key={id}
          onMouseEnter={(e) => e.target.parentElement.style.backgroundColor = '#f8fafc'}
          onMouseLeave={(e) => e.target.parentElement.style.backgroundColor = 'transparent'}
        >
          <td style={styles.td} onClick={(e) => e.stopPropagation()}>
            <label style={styles.checkboxLabel}>
              <input
                type="checkbox"
                className="review-check"
                onChange={checkEach}
                value={id}
                style={styles.checkbox}
              />
            </label>
          </td>
          <td style={styles.td} onClick={onModal}>
            <span style={getReviewTypeStyle(review_type)}>
              {review_type}
            </span>
          </td>
          <td style={{ ...styles.td, ...styles.titleCell }} onClick={onModal}>
            {title}
            {is_admin && <span style={styles.adminBadge}>운영</span>}
          </td>
          <td style={styles.td} onClick={onModal}>{author_name}</td>
          <td style={styles.td} onClick={onModal}>
            <span style={{
              ...styles.memberBadge,
              ...(is_member ? styles.memberYes : styles.memberNo)
            }}>
              {is_member ? "회원" : "비회원"}
            </span>
          </td>
          <td style={styles.td} onClick={onModal}>
            {created_at ? created_at.split(" ")[0] : "-"}
          </td>
        </tr>
      );
    });
  };

  // 후기 다중 삭제
  const deleteReviewsFn = async () => {
    const result = await deleteReviews(idArr);
    if (typeof result === "object") {
      $(".review-all-check").prop("checked", false);
      $(".review-check").prop("checked", false);
      changeState(setPageInfo, "page", 1);
      setIdArr([]);
      setAlert("completeDelete");
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "정상적으로 삭제되었습니다."
      );
      getReviews();
    } else {
      return await catchError(result, navigate, setAlertBox, setAlert);
    }
  };

  // 전체 선택
  const checkAll = () => {
    let arr = [];
    if ($(".review-all-check").is(":checked")) {
      $(".review-check").prop("checked", true);
      const all = $(".review-check").length;
      for (let i = 0; i < all; i++) {
        const val = document.getElementsByClassName("review-check")[i].value;
        arr.push(val);
        setIdArr(arr);
      }
    } else {
      $(".review-check").prop("checked", false);
      setIdArr([]);
    }
  };

  useEffect(() => {
    document.title = "마크픽 관리자 > 고객 후기 관리";
  }, []);

  useEffect(() => {
    if (!modal && !createModal) {
      getReviews();
    }
  }, [pageInfo.page, pageInfo.limit, modal, createModal, answerSelect, reviewType]);

  return (
    <div style={styles.container}>
      {/* 헤더 */}
      <div style={styles.header}>
        <h1 style={styles.title}>
          <FaCommentDots />
          REVIEW
        </h1>

        <div style={styles.controlsContainer} className="controls-container">
          <select
            value={pageInfo.limit}
            onChange={(e) => {
              setPageInfo((prev) => {
                const clone = { ...prev };
                clone.page = 1;
                clone.limit = e.target.value;
                return clone;
              });
            }}
            style={styles.select}
          >
            <option value={10}>10개씩 보기</option>
            <option value={30}>30개씩 보기</option>
            <option value={50}>50개씩 보기</option>
          </select>

          <select
            value={answerSelect}
            onChange={(e) => {
              setAnswerSelect(e.target.value);
              changeState(setPageInfo, "page", 1);
            }}
            style={styles.select}
          >
            <option value="all">전체보기</option>
            <option value="notanswer">답글 미작성</option>
            <option value="answer">답글 작성됨</option>
          </select>

          {/* 후기 유형 필터링 */}
          <select
            value={reviewType}
            onChange={(e) => {
              setReviewType(e.target.value);
              changeState(setPageInfo, "page", 1);
            }}
            style={styles.select}
          >
            <option value="">모든 후기 유형</option>
            {REVIEW_TYPES.map((t) => (
              <option key={t} value={t}>{t}</option>
            ))}
          </select>

          <button
            style={styles.createButton}
            onClick={() => setCreateModal(true)}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#1d4ed8'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
          >
            <FaPlus />
            <span className="button-text">후기 작성</span>
          </button>

          <button
            style={styles.deleteButton}
            onClick={() => {
              if (!idArr.length)
                return commonModalSetting(
                  setAlertBox,
                  true,
                  "alert",
                  "삭제할 후기를 선택해 주세요."
                );
              else {
                setAlert("deleteConfirm");
                commonModalSetting(
                  setAlertBox,
                  true,
                  "confirm",
                  "선택한 후기를 삭제하면 다시 복구할 수 없습니다.<br/>정말 삭제하시겠습니까?"
                );
              }
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#b91c1c'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#dc2626'}
          >
            <FaTrash />
            <span className="button-text">삭제</span>
          </button>
        </div>
      </div>

      {/* 테이블 */}
      <div style={styles.tableContainer}>
        {list?.length ? (
          <div style={styles.tableWrapper} className="table-wrapper">
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>
                    <label style={styles.checkboxLabel}>
                      <input
                        type="checkbox"
                        className="review-all-check"
                        onChange={checkAll}
                        style={styles.checkbox}
                      />
                    </label>
                  </th>
                  <th style={styles.th}>후기 유형</th>
                  <th style={styles.th}>제목</th>
                  <th style={styles.th}>작성자</th>
                  <th style={styles.th}>회원 여부</th>
                  <th style={styles.th}>등록일</th>
                </tr>
              </thead>
              <tbody>{renderTableBody()}</tbody>
            </table>
          </div>
        ) : (
          <div style={styles.emptyState}>목록이 없습니다.</div>
        )}
      </div>

      {/* 페이지네이션 */}
      <Pagination pageInfo={pageInfo} setPageInfo={setPageInfo} />

      {/* 모달들 */}
      {modal ? (
        <CsReviewDetail review={detailReview} setModal={setModal} />
      ) : ""}
      {createModal ? (
        <CsReviewCreateModal
          setModal={setCreateModal}
          onSuccess={() => {
            changeState(setPageInfo, "page", 1);
            getReviews();
          }}
        />
      ) : ""}
      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "logout") navigate("/");
            else if (alert === "deleteConfirm") {
              deleteReviewsFn();
            }
          }}
        />
      )}

      {/* 반응형 스타일 */}
      <style>{`
        @media (max-width: 768px) {
          .table-wrapper {
            -webkit-overflow-scrolling: touch;
          }
          .table-wrapper::-webkit-scrollbar {
            height: 8px;
          }
          .table-wrapper::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 4px;
          }
          .table-wrapper::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 4px;
          }
          .table-wrapper::-webkit-scrollbar-thumb:hover {
            background: #94a3b8;
          }
        }
        @media (max-width: 640px) {
          .controls-container {
            justify-content: center;
          }
          .button-text {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default CsReview;
